/**
 * Нормализует пользовательский ввод числа с плавающей точкой,
 * допуская использование запятой в качестве десятичного разделителя.
 *
 * Правила нормализации:
 * - Удаляются все символы, кроме цифр, знаков `+` или `-` и запятой `,`.
 * - Знак (`+` или `-`) может быть только первым символом; все последующие знаки удаляются.
 * - Допускается не более одной запятой (десятичный разделитель), все последующие запятые удаляются.
 * - Остальные символы (буквы, пробелы, специальные символы) отбрасываются.
 *
 * @param value - Исходная строка, введённая пользователем (например, из поля ввода).
 * @returns Нормализованная строка, пригодная для парсинга в число.
 *          Если ввод был пустым или состоял только из недопустимых символов, вернётся пустая строка.
 */
export const normalizeNumberInput = (value: string): string => {
    const cleanedValue = value.replace(/[^\d-+,]/g, '');

    // Оставляем + или - в начале
    const hasSign = cleanedValue[0] === '+' || cleanedValue[0] === '-';
    const withoutExtraSigns = hasSign
        ? cleanedValue[0] + cleanedValue.slice(1).replace(/[+-]/g, '')
        : cleanedValue.replace(/[+-]/g, '');

    // Оставляем только первую запятую
    const commaIndex = withoutExtraSigns.indexOf(',');
    return commaIndex !== -1
        ? withoutExtraSigns.slice(0, commaIndex + 1) + withoutExtraSigns.slice(commaIndex + 1).replace(/,/g, '')
        : withoutExtraSigns;
};